import { ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, PHONE_VERIFICATION_ACTION, phoneVerification } from '~/actions';
import { Center, ConfirmPopup, Text } from '~/commonComponents';
import { VerificationInput } from '~/commonComponents/VerificationInput';
import { useAppSelector, useLoading } from '~/hooks';
import { useTrackEvent } from '~/hooks/useTrackEvent';
import { POSTHOG_EVENTS } from '~/services/posthog';

interface IProps {
  tel: string;
}

export const VerifyPhonePopup = ({ tel }: IProps): ReactNode => {
  const isOpen = useAppSelector((state) => state.user.pendingPhoneVerification);
  const dispatch = useDispatch();
  const trackPosthogEvent = useTrackEvent();
  const { isLoading } = useLoading([PHONE_VERIFICATION_ACTION]);

  const [code, setCode] = useState('');

  const onClosePopup = () => dispatch(closeModal());

  const onSubmit = (code: string) => {
    // Track PostHog event for verification code submission
    trackPosthogEvent(POSTHOG_EVENTS.DENTAL_PORTAL_MFA_CODE_SUBMITTED);

    dispatch(phoneVerification({ code, phone: tel }));
  };

  useEffect(() => {
    trackPosthogEvent(POSTHOG_EVENTS.DENTAL_PORTAL_MFA_POP_UP_VIEWED);
  }, [trackPosthogEvent]);

  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup still written in Javascript
    <ConfirmPopup
      closePopup={onClosePopup}
      dataCy="confirm-phone-number-popup"
      dataTestId="confirm-phone-number-popup"
      dismissiblePopup={false}
      modalContainerStyle={{ zIndex: 'auto' }}
      rightButtonAction={() => onSubmit(code)}
      rightButtonLoading={isLoading}
      rightButtonText="Submit"
      showClosePopupIcon
    >
      <Text bold fontSize={28}>
        Confirmation Code
      </Text>
      <Center marginBottom={32} marginTop={56}>
        <Text textAlign="center">We sent you a 5 digit confirmation</Text>
        <Text textAlign="center">
          code to <strong>{tel}</strong>
        </Text>
      </Center>
      <Center marginBottom={56}>
        <VerificationInput
          onChange={setCode}
          onComplete={(e) => {
            onSubmit(e);
          }}
        />
      </Center>
    </ConfirmPopup>
  );
};
